import Step from './DashboardBuilderStep'
import { useAct } from 'DashboardBuilder/store'
import useValidateDashboard from 'DashboardBuilder/hooks/useValidateDashboard'
import PreviewTable from '../PreviewTable'

export default function Preview() {
  const act = useAct()
  const {
    id,
    status,
  } = useSel((s) => s.dashboard)

  const [complete, errors] = useValidateDashboard()

  function launch() {
    return act.builder.launch().then((data) => {
      window.location = data.redirectUrl
    })
  }

  return <Step
    name='Preview'
    editor='preview'
    save={launch}
    staticOpenButton={'Preview'}
    finishButtonText={'Launch'}
    canClickFinish={complete}
    validationErrors={errors}
    showDiscard={false}
    showClose={true}
    showSave={status === 'draft'}
    shortDescriptor={
      <p className="incomplete no-margin-bottom">Check everything is OK.</p>
    }
  >
    <PreviewTable dashboardId={id} />
  </Step>
}
